// Shared localStorage adapter for Zustand persist middleware.
// Probes window.localStorage before use (Safari private mode throws on touch)
// and falls back to an in-memory shim so the app stays functional without persistence.

export type MinimalStorage = {
  getItem(name: string): string | null
  setItem(name: string, value: string): void
  removeItem(name: string): void
}

export function createMemoryStorage(): MinimalStorage {
  const mem = new Map<string, string>()
  return {
    getItem: (k) => (mem.has(k) ? (mem.get(k) ?? null) : null),
    setItem: (k, v) => {
      mem.set(k, v)
    },
    removeItem: (k) => {
      mem.delete(k)
    },
  }
}

export function getSafeStorage(): MinimalStorage {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const probe = '__livevane_probe__'
      window.localStorage.setItem(probe, '1')
      window.localStorage.removeItem(probe)
      return window.localStorage
    }
  } catch {
    // Safari private mode or SSR - fall through
  }
  return createMemoryStorage()
}
